export enum PSP {
  Adyen = 'ADYEN',
  Stripe = 'STRIPE',
  StripeIssuing = 'STRIPE_ISSUING',
}
